import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import axios from '../utils/posAxios';
import { MdDone, MdClear } from 'react-icons/md';
import StorageService from '../services/StorageService';

class CrmAddressForm extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      customer_id: this.props.match.params.id,
      address_id: '',
      name: '',
      contact: '',
      address: '',
      unit: '',
      postal_code: '',
      country: '',
    };
  }

  componentDidMount() {
    if (this.props.data.isEdit) {
      let data = this.props.data;
      let address = data.addressList.find(x => x.address_id == data.selectedId);
      this.setState({
        isEdit: data.isEdit,
        address_id: address.address_id,
        name: address.name,
        contact: address.contact,
        address: address.address,
        unit: address.unit,
        postal_code: address.postal_code,
        country: address.country,
      });
    } else {
      let address = this.props.customerData;
      console.log(address);
      this.setState({
        address: address.billing_address,
        unit: address.billing_unit,
        postal_code: address.billing_postal_code,
        country: address.billing_country,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    if (this.state.isEdit) {
      this.editAddress(user, comp, url);
    } else {
      this.addAddress(user, comp, url);
    }
  };

  addAddress(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      customer_id: this.state.customer_id,
      name: this.state.name,
      contact: this.state.contact,
      address: this.state.address,
      unit: this.state.unit,
      country: this.state.country,
      postal_code: this.state.postal_code,
      created_by: user.email,
    };
    axios
      .post(url + ':3004/v1/customer/address/create', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'New Address added successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  editAddress(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      address_id: this.state.address_id,
      name: this.state.name,
      contact: this.state.contact,
      address: this.state.address,
      unit: this.state.unit,
      country: this.state.country,
      postal_code: this.state.postal_code,
      update_by: user.email,
    };

    axios
      .post(url + ':3004/v1/customer/address/update', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Address updated successfully.',
          'success', //'error' post when return error
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  render() {
    const detail = (
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label> Address</Label>
            <Input
              type="text"
              name="address"
              value={this.state.address}
              onChange={this.changeHandler}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label> Unit</Label>
            <Input
              type="text"
              name="unit"
              value={this.state.unit}
              onChange={this.changeHandler}
            />
          </FormGroup>
          <FormGroup>
            <Label> Country</Label>
            <Input
              type="text"
              name="country"
              value={this.state.country}
              onChange={this.changeHandler}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label>Postal Code</Label>
            <Input
              type="text"
              name="postal_code"
              maxLength={6}
              value={this.state.postal_code}
              onChange={this.changeHandler}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label>Contact</Label>
            <Input
              type="text"
              name="contact"
              value={this.state.contact}
              onChange={this.changeHandler}
            />
          </FormGroup>
          <FormGroup>
            <Label>Name</Label>
            <Input
              type="text"
              name="name"
              value={this.state.name}
              onChange={this.changeHandler}
              required
            />
          </FormGroup>
        </Col>
      </Row>
    );

    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>Address</ModalHeader>
        <ModalBody>{detail}</ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    );
  }
}

export const STATE_ADD = 'ADD';
export const STATE_EDIT = 'EDIT';
export default CrmAddressForm;
